
export default {
  altitudePreview: {
    'expandAltitudeChart': 'Diagram kibontása',
    'altitude': 'Magasság'
  }
}
